// Formant-staff view of what robot onboardings ran on — device type,
// category, OS, arch — and the latest failures per device:
// `/internal/robot-plans/devices`. Filters (`range`, `org`, `dim`) live in
// the search params like the overview's.
import { createFileRoute } from '@tanstack/react-router';

import { RobotPlansDevicesPage } from '../../../components/robot-plans/RobotPlansDevicesPage';
import { parseRobotPlansDevicesSearch } from '../../../components/robot-plans/robot-plans-model';
import { guardSuperuser } from '../index';

export const Route = createFileRoute('/internal/robot-plans/devices')({
  beforeLoad: () => guardSuperuser(),
  validateSearch: parseRobotPlansDevicesSearch,
  component: RobotPlansDevicesPage,
});
